export enum Capability {
  ACCESS_CONSOLE = 'access-console',
  APPROVE_ABSENCE = 'approve-absence',
  APPROVE_AS_HR = 'approve-as-hr',
  APPROVE_AS_MANAGER = 'approve-as-manager',
  APPROVE_EVALUATION = 'approve-evaluation',
  APPROVE_GOALS_EVALUATION = 'approve-goals-evaluation',
  ARCHIVE_EVALUATION = 'archive-evaluation',
  ARCHIVE_GOALS_EVALUATION = 'archive-goals-evaluation',
  AUTHENTICATED = 'authenticated',
  CREATE_ABSENCE = 'create-absence',
  CREATE_ACKNOWLEDGEMENT = 'create-acknowledgement',
  CREATE_APPRAISAL = 'create-appraisal',
  CREATE_BONUS_CALC_RULE = 'create-bonus-calc-rule',
  CREATE_CANDIDATE = 'create-candidate',
  CREATE_CLIENTERROR = 'create-clienterror',
  CREATE_CUSTOM_DATA_SCHEMA = 'create-custom-data-schema',
  CREATE_DECISION = 'create-decision',
  CREATE_DEV_COMPANY = 'create-dev-company',
  CREATE_DOCUMENT = 'create-document',
  CREATE_EARLY_INVOLVEMENT = 'create-early-involvement',
  CREATE_EMPLOYEE = 'create-employee',
  CREATE_EMPLOYMENT = 'create-employment',
  CREATE_EMPL_PENDING = 'create-empl-pending',
  CREATE_EMPL_RESTRICTED = 'create-empl-restricted',
  CREATE_EMP_PENDING = 'create-emp-pending',
  CREATE_ENUM = 'create-enum',
  CREATE_EQUIPMENT = 'create-equipment',
  CREATE_EVALUATION = 'create-evaluation',
  CREATE_GOALS = 'create-goals',
  CREATE_GOALS_EVALUATION = 'create-goals-evaluation',
  CREATE_HOLIDAY = 'create-holiday',
  CREATE_JOB_APPLICATION = 'create-job-application',
  CREATE_JOB_APP_PUBLIC = 'create-job-app-public',
  CREATE_JOB_OPENING = 'create-job-opening',
  CREATE_MAIL_TEMPL = 'create-mail-templ',
  CREATE_NOTIFICATION = 'create-notification',
  CREATE_OFFICE = 'create-office',
  CREATE_ORGUNIT = 'create-orgunit',
  CREATE_PLANNING = 'create-planning',
  CREATE_POST = 'create-post',
  CREATE_REPORT_SETTINGS = 'create-report-settings',
  CREATE_SECONDARY_EMPLOYMENT = 'create-secondary-employment',
  CREATE_STRING = 'create-string',
  CREATE_SURVEY = 'create-survey',
  CREATE_TASK = 'create-task',
  CREATE_TIMESHEET_SETTINGS = 'create-timesheet-settings',
  CREATE_TREE = 'create-tree',
  CREATE_USER = 'create-user',
  CREATE_USER_ENUM = 'create-user-enum',
  CREATE_WORKFLOW = 'create-workflow',
  CREATE_WORKLIST = 'create-worklist',
  DELETE_APPRAISAL = 'delete-appraisal',
  DELETE_EARLY_INVOLVEMENT = 'delete-early-involvement',
  DELETE_GOALS = 'delete-goals',
  DELETE_REPORT_SETTINGS = 'delete-report-settings',
  DELETE_TIMESHEET = 'delete-timesheet',
  DELETE_TIME_CARD = 'delete-time-card',
  EDIT_ABSENCE = 'edit-absence',
  EDIT_ACKNOWLEDGEMENT = 'edit-acknowledgement',
  EDIT_APPCONFIG = 'edit-appconfig',
  EDIT_BONUS_CALC_RULE = 'edit-bonus-calc-rule',
  EDIT_CANDIDATE = 'edit-candidate',
  EDIT_COMPANY = 'edit-company',
  EDIT_COMPANY_CONFIG = 'edit-company-config',
  EDIT_COMPANY_FILE = 'edit-company-file',
  EDIT_COMPANY_TRAINING_PARTICIPANT = 'edit-company-training-participant',
  EDIT_CUSTOM_DATA = 'edit-custom-data',
  EDIT_CUSTOM_DATA_BILLABLE_HOURS_PROPOSAL = 'edit-custom-data-billable-hours-proposal',
  EDIT_CUSTOM_DATA_COST_CENTER = 'edit-custom-data-cost-center',
  EDIT_CUSTOM_DATA_DECISION_REGISTRY = 'edit-custom-data-decision-registry',
  EDIT_CUSTOM_DATA_EMPLOYEE = 'edit-custom-data-employee',
  EDIT_CUSTOM_DATA_EMPLOYEE_POS = 'edit-custom-data-employee-pos',
  EDIT_CUSTOM_DATA_EMPLOYMENT = 'edit-custom-data-employment',
  EDIT_CUSTOM_DATA_JOB_APPLICATION = 'edit-custom-data-job-application',
  EDIT_CUSTOM_DATA_SCHEMA = 'edit-custom-data-schema',
  EDIT_DEV_COMPANY = 'edit-dev-company',
  EDIT_DEV_EXPERIENCE_REGULAR = 'edit-dev-experience-regular',
  EDIT_DEV_EXPERIENCE_SENSITIVE = 'edit-dev-experience-sensitive',
  EDIT_DEV_REGULAR = 'edit-dev-regular',
  EDIT_DEV_SENSITIVE = 'edit-dev-sensitive',
  EDIT_DMGR_UNIT = 'edit-dmgr-unit',
  EDIT_DOCUMENT = 'edit-document',
  EDIT_DOC_APPROVAL = 'edit-doc-approval',
  EDIT_DOC_APPROVAL_STATUS = 'edit-doc-approval-status',
  EDIT_EMPLOYMENT = 'edit-employment',
  EDIT_EMPLOYMENT_BASIC = 'edit-employment-basic',
  EDIT_EMPLOYMENT_DETAIL = 'edit-employment-detail',
  EDIT_EMPLOYMENT_INFO = 'edit-employment-info',
  EDIT_EMPL_BANKACCOUNT = 'edit-empl-bankaccount',
  EDIT_EMPL_START = 'edit-empl-start',
  EDIT_EMP_BASIC = 'edit-emp-basic',
  EDIT_EMP_CONTRACT_NUMBER = 'edit-emp-contract-number',
  EDIT_EMP_EME = 'edit-emp-eme',
  EDIT_EMP_FULL = 'edit-emp-full',
  EDIT_EMP_HOME = 'edit-emp-home',
  EDIT_EMP_INFO = 'edit-emp-info',
  EDIT_EMP_NUMBER = 'edit-emp-number',
  EDIT_EMP_OFFICE = 'edit-emp-office',
  EDIT_EMP_OTHER = 'edit-emp-other',
  EDIT_EMP_PROFILE = 'edit-emp-profile',
  EDIT_EMP_PROFILE_INFO = 'edit-emp-profile-info',
  EDIT_EMP_WORK = 'edit-emp-work',
  EDIT_ENUM = 'edit-enum',
  EDIT_ENUM_ADMIN = 'edit-enum-admin',
  EDIT_EQUIPMENT = 'edit-equipment',
  EDIT_HOLIDAY = 'edit-holiday',
  EDIT_HR_UNIT = 'edit-hr-unit',
  EDIT_JOB_APPLICATION = 'edit-job-application',
  EDIT_JOB_OPENING = 'edit-job-opening',
  EDIT_MAIL_TEMPL = 'edit-mail-templ',
  EDIT_MGR_NOTE = 'edit-mgr-note',
  EDIT_MGR_NOTE_EMP = 'edit-mgr-note-emp',
  EDIT_NOTIFICATION = 'edit-notification',
  EDIT_OFFICE = 'edit-office',
  EDIT_ORGUNIT = 'edit-orgunit',
  EDIT_PERFORMANCE = 'edit-performance',
  EDIT_PLANNING = 'edit-planning',
  EDIT_POST = 'edit-post',
  EDIT_RESP_UNIT = 'edit-resp-unit',
  EDIT_STRING = 'edit-string',
  EDIT_TASK = 'edit-task',
  EDIT_TASK_STATE = 'edit-task-state',
  EDIT_TIMESHEET_SETTINGS = 'edit-timesheet-settings',
  EDIT_TREE = 'edit-tree',
  EDIT_USER_LANGUAGE = 'edit-user-language',
  EDIT_USER_PASSWORD = 'edit-user-password',
  EDIT_USER_ROLES = 'edit-user-roles',
  EDIT_USER_SETTING = 'edit-user-setting',
  EDIT_USER_STATUS = 'edit-user-status',
  EDIT_USER_USERNAME = 'edit-user-username',
  EDIT_VACATION_BALANCE = 'edit-vacation-balance',
  EDIT_WORKFLOW = 'edit-workflow',
  EDIT_WORKLIST = 'edit-worklist',
  EXEC_EMAIL = 'exec-email',
  GET_TOKEN = 'get-token',
  GRAPHQL = 'graphql',
  HARD_REMOVE_ABSENCE = 'hard-remove-absence',
  HARD_REMOVE_COSTCENTER = 'hard-remove-costcenter',
  HARD_REMOVE_CUSTOM_DATA_SCHEMA = 'hard-remove-custom-data-schema',
  HARD_REMOVE_JOB_OPENING = 'hard-remove-job-opening',
  HARD_REMOVE_LEGALENTITY = 'hard-remove-legalentity',
  HARD_REMOVE_OFFICE = 'hard-remove-office',
  HARD_REMOVE_ORGUNIT = 'hard-remove-orgunit',
  IS_AMGR_RESP = 'is-amgr-resp',
  IS_DMGR_RESP = 'is-dmgr-resp',
  IS_HRADMIN_RESP = 'is-hradmin-resp',
  IS_HR_RESP = 'is-hr-resp',
  IS_ITADMIN_RESP = 'is-itadmin-resp',
  IS_MGR_RESP = 'is-mgr-resp',
  LOGIN = 'login',
  LOGOUT = 'logout',
  MANAGE_BACKUP = 'manage-backup',
  MANAGE_COMPANY_TRAININGS = 'manage-company-trainings',
  MANAGE_COMPANY_TRAINING_PARTICIPANTS = 'manage-company-training-participants',
  MANAGE_ENUM_SCORE_GROUP = 'manage-enum-score-group',
  MANAGE_JOB_REQUIREMENT = 'manage-job-requirement',
  MANAGE_TIME_CARD = 'manage-time-card',
  MANAGE_TRANSLATIONS = 'manage-translations',
  RAISE_SUPPORT_REQUEST = 'raise-support-request',
  REGISTER_FOR_COMPANY_TRAINING = 'register-for-company-training',
  REGISTER_FOR_PUBLIC_COMPANY_TRAINING = 'register-for-public-company-training',
  REMOVE_ABSENCE = 'remove-absence',
  REMOVE_ACKNOWLEDGEMENT = 'remove-acknowledgement',
  REMOVE_BONUS_CALC_RULE = 'remove-bonus-calc-rule',
  REMOVE_CANDIDATE = 'remove-candidate',
  REMOVE_CUSTOM_DATA_SCHEMA = 'remove-custom-data-schema',
  REMOVE_DEV_COMPANY = 'remove-dev-company',
  REMOVE_DEV_EXPERIENCE_REGULAR = 'remove-dev-experience-regular',
  REMOVE_DEV_EXPERIENCE_SENSITIVE = 'remove-dev-experience-sensitive',
  REMOVE_DEV_HISTORY = 'remove-dev-history',
  REMOVE_DEV_REGULAR = 'remove-dev-regular',
  REMOVE_DEV_SENSITIVE = 'remove-dev-sensitive',
  REMOVE_DOCUMENT = 'remove-document',
  REMOVE_EMPLOYEE = 'remove-employee',
  REMOVE_EMPLOYEES_BULK = 'remove-employees-bulk',
  REMOVE_EMPLOYMENT = 'remove-employment',
  REMOVE_EMP_PROFILE = 'remove-emp-profile',
  REMOVE_ENUM = 'remove-enum',
  REMOVE_EQUIPMENT = 'remove-equipment',
  REMOVE_HOLIDAY = 'remove-holiday',
  REMOVE_JOB_APPLICATION = 'remove-job-application',
  REMOVE_JOB_OPENING = 'remove-job-opening',
  REMOVE_MAIL_TEMPL = 'remove-mail-templ',
  REMOVE_MGR_NOTE = 'remove-mgr-note',
  REMOVE_NOTIFICATION = 'remove-notification',
  REMOVE_OFFICE = 'remove-office',
  REMOVE_ORGUNIT = 'remove-orgunit',
  REMOVE_PERF_HISTORY = 'remove-perf-history',
  REMOVE_PERF_REGULAR = 'remove-perf-regular',
  REMOVE_PLANNING = 'remove-planning',
  REMOVE_POST = 'remove-post',
  REMOVE_STRING = 'remove-string',
  REMOVE_TASK = 'remove-task',
  REMOVE_TREE = 'remove-tree',
  REMOVE_USER = 'remove-user',
  REMOVE_USER_ENUM = 'remove-user-enum',
  REMOVE_VACATION_BALANCE = 'remove-vacation-balance',
  REMOVE_WORKFLOW = 'remove-workflow',
  RESET = 'reset',
  RUN_BATCH = 'run-batch',
  RUN_BATCH_BASIC = 'run-batch-basic',
  SEND_DOC_APPROVAL = 'send-doc-approval',
  SEND_EMAIL_HR = 'send-email-hr',
  SEND_GROUP_EMAIL = 'send-group-email',
  SOLAINTEL_CREATE_INDICATOR = 'solaintel-create-indicator',
  SOLAINTEL_DELETE_INDICATOR = 'solaintel-delete-indicator',
  SOLAINTEL_EDIT_INDICATOR = 'solaintel-edit-indicator',
  SOLAINTEL_VIEW_INDICATOR = 'solaintel-view-indicator',
  SOLAINTEL_VIEW_INDICATOR_RESULTS = 'solaintel-view-indicator-results',
  SOLAPULSE_ANSWER_SURVEY = 'solapulse-answer-survey',
  SOLAPULSE_CREATE_SURVEY = 'solapulse-create-survey',
  SOLAPULSE_MANAGE_SURVEY = 'solapulse-manage-survey',
  SOLAPULSE_VIEW_ACTIVE_SURVEY = 'solapulse-view-active-survey',
  SOLAPULSE_VIEW_NOTIFICATION = 'solapulse-view-notification',
  SOLAPULSE_VIEW_RESULTS = 'solapulse-view-results',
  SOLAPULSE_VIEW_SURVEY = 'solapulse-view-survey',
  UNREGISTER_FOR_COMPANY_TRAINING = 'unregister-for-company-training',
  UPDATE_APPRAISAL = 'update-appraisal',
  UPDATE_DECISION = 'update-decision',
  UPDATE_EARLY_INVOLVEMENT = 'update-early-involvement',
  UPDATE_GOALS = 'update-goals',
  UPDATE_REPORT_SETTINGS = 'update-report-settings',
  VIEW_ABSENCE = 'view-absence',
  VIEW_ABSENCE_VACATION = 'view-absence-vacation',
  VIEW_ACKNOWLEDGEMENT = 'view-acknowledgement',
  VIEW_ALL_COMPANY_TRAININGS = 'view-all-company-trainings',
  VIEW_APPCONFIG = 'view-appconfig',
  VIEW_APPRAISAL = 'view-appraisal',
  VIEW_APPRAISAL_REPORT = 'view-appraisal-report',
  VIEW_BONUS_CALC_RULE = 'view-bonus-calc-rule',
  VIEW_CANDIDATE = 'view-candidate',
  VIEW_COMPANY = 'view-company',
  VIEW_COMPANY_FILE = 'view-company-file',
  VIEW_COMPANY_NAME = 'view-company-name',
  VIEW_COMPANY_SENSITIVE = 'view-company-sensitive',
  VIEW_COMPANY_TRAINING_PARTICIPANTS = 'view-company-training-participants',
  VIEW_CUSTOM_DATA = 'view-custom-data',
  VIEW_CUSTOM_DATA_BILLABLE_HOURS_PAID = 'view-custom-data-billable-hours-paid',
  VIEW_CUSTOM_DATA_BILLABLE_HOURS_PROPOSAL = 'view-custom-data-billable-hours-proposal',
  VIEW_CUSTOM_DATA_COST_CENTER = 'view-custom-data-cost-center',
  VIEW_CUSTOM_DATA_DECISION_REGISTRY = 'view-custom-data-decision-registry',
  VIEW_CUSTOM_DATA_EMPLOYEE = 'view-custom-data-employee',
  VIEW_CUSTOM_DATA_EMPLOYEE_POS = 'view-custom-data-employee-pos',
  VIEW_CUSTOM_DATA_EMPLOYMENT = 'view-custom-data-employment',
  VIEW_CUSTOM_DATA_JOB_APPLICATION = 'view-custom-data-job-application',
  VIEW_CUSTOM_DATA_SCHEMA = 'view-custom-data-schema',
  VIEW_CUSTOM_DATA_TIMESHEET = 'view-custom-data-timesheet',
  VIEW_DECISION = 'view-decision',
  VIEW_DECISION_REPORT = 'view-decision-report',
  VIEW_DEVELOPMENT = 'view-development',
  VIEW_DEV_EXPERIENCE = 'view-dev-experience',
  VIEW_DMGR_EMPLOYEES = 'view-dmgr-employees',
  VIEW_DMGR_UNIT = 'view-dmgr-unit',
  VIEW_DOCUMENT = 'view-document',
  VIEW_DOC_APPROVAL = 'view-doc-approval',
  VIEW_DOC_APPROVAL_FILE = 'view-doc-approval-file',
  VIEW_EARLY_INVOLVEMENT = 'view-early-involvement',
  VIEW_EARLY_INVOLVEMENT_REPORT = 'view-early-involvement-report',
  VIEW_EMPLOYEE_COMPANY_TRAININGS = 'view-employee-company-trainings',
  VIEW_EMPLOYMENT = 'view-employment',
  VIEW_EMPLOYMENT_BASIC = 'view-employment-basic',
  VIEW_EMPLOYMENT_BASIC_REHIRE = 'view-employment-basic-rehire',
  VIEW_EMP_BASIC = 'view-emp-basic',
  VIEW_EMP_BIRTHDAY = 'view-emp-birthday',
  VIEW_EMP_BY_ROLE = 'view-emp-by-role',
  VIEW_EMP_EME = 'view-emp-eme',
  VIEW_EMP_ENDED_EDITABLE = 'view-emp-ended-editable',
  VIEW_EMP_FILTERED = 'view-emp-filtered',
  VIEW_EMP_FULL = 'view-emp-full',
  VIEW_EMP_HOME = 'view-emp-home',
  VIEW_EMP_OTHER = 'view-emp-other',
  VIEW_EMP_PROFILE = 'view-emp-profile',
  VIEW_EMP_SSN = 'view-emp-ssn',
  VIEW_EMP_USERNAME = 'view-emp-username',
  VIEW_EMP_WORK = 'view-emp-work',
  VIEW_ENUM = 'view-enum',
  VIEW_ENUM_SCORE_GROUP = 'view-enum-score-group',
  VIEW_EQUIPMENT = 'view-equipment',
  VIEW_EVALUATION = 'view-evaluation',
  VIEW_GOALS = 'view-goals',
  VIEW_GOALS_EVALUATION = 'view-goals-evaluation',
  VIEW_GOALS_REPORT = 'view-goals-report',
  VIEW_HOLIDAY = 'view-holiday',
  VIEW_HR_UNIT = 'view-hr-unit',
  VIEW_JOB_APPLICATION = 'view-job-application',
  VIEW_JOB_OPENING = 'view-job-opening',
  VIEW_JOB_OPENING_PUBLIC = 'view-job-opening-public',
  VIEW_JOB_REQUIREMENT = 'view-job-requirement',
  VIEW_MAIL_TEMPL = 'view-mail-templ',
  VIEW_MGR_NOTE = 'view-mgr-note',
  VIEW_MGR_NOTE_EMP = 'view-mgr-note-emp',
  VIEW_MODULE = 'view-module',
  VIEW_NOTIFICATION = 'view-notification',
  VIEW_OFFICE = 'view-office',
  VIEW_ORGUNIT = 'view-orgunit',
  VIEW_PERFORMANCE = 'view-performance',
  VIEW_PLANNING = 'view-planning',
  VIEW_POST = 'view-post',
  VIEW_POST_PUB = 'view-post-pub',
  VIEW_PUBLIC_COMPANY_TRAININGS = 'view-public-company-trainings',
  VIEW_PUBLIC_DOCUMENT = 'view-public-document',
  VIEW_REPORT_AMGR = 'view-report-amgr',
  VIEW_REPORT_AMGR_SENSITIVE = 'view-report-amgr-sensitive',
  VIEW_REPORT_COMPANY = 'view-report-company',
  VIEW_REPORT_COMPANY_BASIC = 'view-report-company-basic',
  VIEW_REPORT_COMPANY_LIMITED = 'view-report-company-limited',
  VIEW_REPORT_COMPANY_SENSITIVE = 'view-report-company-sensitive',
  VIEW_REPORT_DMGR = 'view-report-dmgr',
  VIEW_REPORT_EMPLOYEE = 'view-report-employee',
  VIEW_REPORT_HR = 'view-report-hr',
  VIEW_REPORT_HR_APPRAISAL = 'view-report-hr-appraisal',
  VIEW_REPORT_HR_DECISION = 'view-report-hr-decision',
  VIEW_REPORT_HR_EARLY_INVOLVEMENT = 'view-report-hr-early-involvement',
  VIEW_REPORT_HR_SENSITIVE = 'view-report-hr-sensitive',
  VIEW_REPORT_LEGENT = 'view-report-legent',
  VIEW_REPORT_LEGENT_BASIC = 'view-report-legent-basic',
  VIEW_REPORT_LEGENT_LIMITED = 'view-report-legent-limited',
  VIEW_REPORT_LEGENT_SENSITIVE = 'view-report-legent-sensitive',
  VIEW_REPORT_MANAGER = 'view-report-manager',
  VIEW_REPORT_MANAGER_APPRAISAL = 'view-report-manager-appraisal',
  VIEW_REPORT_MANAGER_DECISION = 'view-report-manager-decision',
  VIEW_REPORT_MANAGER_EARLY_INVOLVEMENT = 'view-report-manager-early-involvement',
  VIEW_REPORT_MANAGER_SENSITIVE = 'view-report-manager-sensitive',
  VIEW_REPORT_SETTINGS = 'view-report-settings',
  VIEW_REPORT_UNIT = 'view-report-unit',
  VIEW_REPORT_UNIT_BASIC = 'view-report-unit-basic',
  VIEW_REPORT_UNIT_LIMITED = 'view-report-unit-limited',
  VIEW_REPORT_UNIT_SENSITIVE = 'view-report-unit-sensitive',
  VIEW_RESP_UNIT = 'view-resp-unit',
  VIEW_ROLE_CAPABILITY = 'view-role-capability',
  VIEW_STRING = 'view-string',
  VIEW_SUMMARY_COMPANY = 'view-summary-company',
  VIEW_SUMMARY_COMPANY_SENSITIVE = 'view-summary-company-sensitive',
  VIEW_SUMMARY_LEGENT = 'view-summary-legent',
  VIEW_SUMMARY_LEGENT_SENSITIVE = 'view-summary-legent-sensitive',
  VIEW_TARGETED_COMPANY_TRAININGS = 'view-targeted-company-trainings',
  VIEW_TASK = 'view-task',
  VIEW_TIMESHEET = 'view-timesheet',
  VIEW_TIMESHEET_SETTINGS = 'view-timesheet-settings',
  VIEW_TIME_CARD = 'view-time-card',
  VIEW_TRANSLATIONS = 'view-translations',
  VIEW_TREE = 'view-tree',
  VIEW_USER = 'view-user',
  VIEW_USER_FULL = 'view-user-full',
  VIEW_USER_LOGIN_INFO = 'view-user-login-info',
  VIEW_VACATION_BALANCE = 'view-vacation-balance',
  VIEW_WORKFLOW = 'view-workflow',
  VIEW_WORKLIST = 'view-worklist',
}
